import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmissionPublicationRequestForm } from '../forms/SubmissionPublicationRequestForm';

type SubmissionPublicationRequestModalProps = {
  submissionUuid: string;
  name: string;
  isOpen: boolean;
  onClose: () => void;
};

export const SubmissionPublicationRequestModal = ({
  submissionUuid,
  name,
  isOpen,
  onClose,
}: SubmissionPublicationRequestModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      isOpen={isOpen}
      loading={loading}
      onRequestClose={() => onClose()}
      title={t('submissions.requestPublication')}
    >
      <SubmissionPublicationRequestForm
        submissionUuid={submissionUuid}
        name={name}
        onLoading={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
